/**
 * @generated SignedSource<<c00254c2b5ed9c1df6e20adbe7ef892b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_rankField$data = {
  readonly rankField?: {
    readonly aliases: ReadonlyArray<string> | null | undefined;
    readonly jqlTerm: string;
    readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_rankField">;
  } | null | undefined;
  readonly " $fragmentType": "main_issueNavigator_ListView_rankField";
};
export type main_issueNavigator_ListView_rankField$key = {
  readonly " $data"?: main_issueNavigator_ListView_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_rankField",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraJqlFieldWithAliases",
          "kind": "LinkedField",
          "name": "rankField",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "jqlTerm"
            },
            {
              "kind": "ScalarField",
              "name": "aliases"
            },
            {
              "kind": "FragmentSpread",
              "name": "ui_nativeIssueTable_NativeIssueTable_rankField"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "0e5146484295a28e4157878ac2c23f63";

export default node;
